import React from "react";
import { connect } from "react-redux";
import { formatNumber, formatNumberForceSigned } from "../../../lib/commonFunctions";

const FoodBalance = ({ foodBalance }) => (
  <React.Fragment>
    <h3 className="title">Food balance</h3>
    Bakers: <span
    className={foodBalance.production.bakers > 0 ? "positive" : ""}>{formatNumberForceSigned(foodBalance.production.bakers)}</span><br/>
    {!!foodBalance.production.guilds && <>
      Guild: <span className={"positive"}>{formatNumberForceSigned(foodBalance.production.guilds)}</span><br />
    </>}
    Serfs: <span
    className={foodBalance.production.serfs > 0 ? "positive" : undefined}>{formatNumberForceSigned(foodBalance.production.serfs)}</span><br/>
    Consumption: {foodBalance.foodRaid ? <span className="positive">0 (food raid)</span>
      : <span className="negative">{formatNumber(-foodBalance.consumption)}</span>}
  </React.Fragment>
);

const mapStateToProps = state => ({
  foodBalance: state.governorate.resourceBalances.food,
});


export default connect(mapStateToProps)(FoodBalance);
